/* eslint-disable jsx-a11y/img-redundant-alt */
import { IconOtherSound } from '@doltech/icons/IconOtherSound';
import { numberToABC } from '@doltech/utils/lib/text';
import { Spin } from 'antd';
import cl from 'classnames';
import { noop } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../../../colors-v2';
import { showToast } from '../../../../../../Toast';
import { DoTestQuizAnswerModeEnum } from '../../../types';
import { OptionShareStyles } from './OptionText';
import { s3ToCDN } from '@doltech/utils/lib/url';
import { useSimpleAudioPlayInBackgroundStore } from '../../../../../../../hooks/simple-audio-play-in-background.store';

/* stylelint-disable no-descending-specificity */
const Main = styled.div`
  ${OptionShareStyles}
  position: relative;
  border-radius: 8px;
  padding: 32px 12px;
  min-height: 56px;
  overflow: hidden;

  .poll-result {
    position: absolute;
    bottom: -1px;
    right: -1px;
    padding: 2px 8px;
    z-index: 2;
    border-radius: 8px 0;
    user-select: none;
  }
  .poll-text {
    font-size: 10px;
    font-weight: 600;
    line-height: 20px;
    color: ${colorsV2.white100};
  }

  .choice-wrapper {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: 24px minmax(0, 1fr);
    align-items: center;
    gap: 10px;
    user-select: none;

    .audio-wrapper {
      font-size: 24px;
      line-height: 0;
      text-align: center;
      display: grid;
      place-items: center;
    }
    .circle-text {
      display: grid;
      place-items: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: ${colorsV2.black20};
      color: ${colorsV2.white100};

      font-size: 12px;
      font-weight: 600;
      line-height: 1;
      letter-spacing: 0;
      text-align: center;
    }
  }

  &.${DoTestQuizAnswerModeEnum.DO_TEST} {
    &:active,
    &.selected {
      .circle-text {
        background: ${colorsV2.blue100};
      }
    }
    .poll-result {
      display: none;
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_WRONG} {
    border: 2px solid ${colorsV2.red100};
    background-color: ${colorsV2.red10};
    .choice-wrapper {
      color: ${colorsV2.black100};
    }
    .circle-text,
    .poll-result {
      background-color: ${colorsV2.red100};
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_CORRECT} {
    border: 2px solid ${colorsV2.green100};
    background-color: ${colorsV2.green10};
    .choice-wrapper {
      color: ${colorsV2.black100};
    }
    .circle-text,
    .poll-result {
      background-color: ${colorsV2.green100};
    }
  }

  &.${DoTestQuizAnswerModeEnum.RESULT_DEFAULT} {
    border: 1px solid ${colorsV2.gray20};
    background-color: ${colorsV2.white100};
    .poll-result {
      display: none;
      color: ${colorsV2.gray100};
    }
  }
`;

interface OptionAudioProps {
  mode: DoTestQuizAnswerModeEnum;
  selected?: boolean;
  text: string;
  audio: any;
  audioType?: 'GOOGLE' | 'UPLOAD';

  percentage?: number;
  onClick?: (e: any) => void;
  optionIndex: number;
}

export const OptionAudio = observer((props: OptionAudioProps) => {
  const {
    optionIndex,
    mode,
    selected,
    percentage = 0,
    text,
    audio,
    audioType,
    onClick = noop,
  } = props;
  const audioStore = useSimpleAudioPlayInBackgroundStore();
  return (
    <Main
      onClick={(e) => {
        switch (audioType) {
          case 'GOOGLE': {
            audioStore?.playByText(text);
            break;
          }
          case 'UPLOAD': {
            audioStore?.play(s3ToCDN(audio?.path));
            break;
          }
          default: {
            showToast({
              icon: 'danger',
              title: 'Oops, something went wrong',
              subTitle: `Audio type: [${audioType}] not supported`,
            });
          }
        }
        onClick(e);
      }}
      className={cl('quizz-answer-option-audio', mode, { selected })}
    >
      <div
        onMouseDown={(e) => e.preventDefault()}
        contentEditable={false}
        className="choice-wrapper"
      >
        <div
          onMouseDown={(e) => e.preventDefault()}
          contentEditable={false}
          className="circle-text"
        >
          {numberToABC(optionIndex + 1)}
        </div>
        <Spin spinning={audioStore?.state === 'pending' && selected}>
          <div
            onMouseDown={(e) => e.preventDefault()}
            contentEditable={false}
            className="audio-wrapper"
          >
            <IconOtherSound />
          </div>
        </Spin>
      </div>

      <div onMouseDown={(e) => e.preventDefault()} contentEditable={false} className="poll-result">
        <div onMouseDown={(e) => e.preventDefault()} contentEditable={false} className="poll-text">
          {percentage}% chọn
        </div>
      </div>
    </Main>
  );
});
